import { render, staticRenderFns } from "./LoggedInUserBar.vue?vue&type=template&id=09c2de2d"
import script from "./LoggedInUserBar.vue?vue&type=script&lang=js"
export * from "./LoggedInUserBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports